export default "/_next/static/assets/a856869ca8c7411f908bd47e5dbc03cd.mp3";